import api from '@pray/shared/utils/api';

export async function getAllEmailCampaigns({
  artistId = '',
  offset = 0,
  limit = 0,
  search = '',
  sortColumn = '',
  sortDirection = 'asc',
  status = '',
} = {}) {
  const params = {};

  if (offset) params.offset = offset;

  if (limit) params.limit = limit;

  if (search.trim()) params.search = search.trim();

  if (status) params.status = status;

  if (sortColumn) {
    params.sort_column = sortColumn;
    params.sort_direction = sortDirection;
  }

  const url = `/web/studio/artists/${artistId}/campaigns/emails`;
  const response = await api.executeGetRequest(url, params);

  return response.data;
}
